/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.08.2016.
 */

import Episode from './episode';

export default Episode;



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Widgets/Episode/index.js